<template>
  <div class="FinancesPayoutsTaxesTable">
    <b-table :fields="fields" :items="items">
      <template #cell(amount)="{ item, index }">
        <div>
          <b-form-input
            type="number"
            no-wheel
            v-model="item.amount"
            @input="editAmount(item)"
            v-b-tooltip.hover="{ variant: 'base' }"
            :title="item.is_manually_edit ? 'Manually edited amount. For auto calculation click checkbox' : 'Auto calculated amount'"
          />
          <span class="currency-code">{{ currencyCode }}</span>
        </div>
      </template>
      <template #cell(is_manually_edit)="{ item, index }">
        <div>
          <b-form-checkbox
            size="sm"
            switch
            v-model="item.is_manually_edit"
            class="switch"
            v-b-tooltip.hover="{ variant: 'base' }"
            :title="item.is_manually_edit ? 'Auto calculation' : 'Fix taxes'"
            @change="!item.is_manually_edit ? calculatePayout() : null"
          >
          </b-form-checkbox>
        </div>
      </template>
      <template #cell(tax_type)="{ item, index }">
        <div> {{ item.tax_type.tax_type_name }}</div>
      </template>
      <template #cell(user)="{ item, index }">
        <div> {{ item.user.name }}</div>
      </template>
      <template #cell(description)="{ item, index }">
        <b-form-textarea
          id="textarea"
          v-model="item.description"
          rows="3"
          max-rows="6"
          @input="item.is_manually_edit = true"
        >
        </b-form-textarea>
      </template>
    </b-table>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    currencyCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      fields: [
        { key: 'tax_type', label: 'Tax type', class: 'name-column' },
        { key: 'user', label: 'Contractor', class: 'name-column' },
        { key: 'amount', label: 'Amount', class: 'amount-column' },
        { key: 'is_manually_edit', label: 'Manually', class: 'actions-column' },
        { key: 'description', label: 'Description', class: 'description-column' }
      ],
      items: []
    }
  },
  mounted () {
    this.setInitialParams()
  },
  watch: {
    'value': {
      deep: true,
      handler () {
        this.setInitialParams()
      }
    }
  },
  methods: {
    setInitialParams () {
      this.items = this.value || []
      this.triggerInputEmit()
    },
    triggerInputEmit () {
      this.$emit('input', this.items)
    },
    calculatePayout () {
      this.$emit('calculatePayout')
    },
    editAmount (item) {
      item.is_manually_edit = true
      this.calculatePayout()
    }
  }
}
</script>

<style lang="scss">
  .FinancesPayoutsTaxesTable{
    margin-bottom: 1rem;
    .name-column {
      width: 160px;
    }
    .actions-column {
      width: 40px;
    }
    .amount-column {
      width: 120px;
    }
    .description-column {
      width: auto;
    }
    .currency-code {
      float: right;
      margin-top: -28px;
      margin-right: 4px;
    }
  }
</style>
